import DataTable from "@visa/vds/data-table";
import Th from "@visa/vds/th";
import Thead from "@visa/vds/thead";
import Tr from "@visa/vds/tr";
import Typography from "@visa/vds/typography";
import React, { useMemo } from "react";
import { ReactSortable } from "react-sortablejs";
import uuid from "react-uuid";

const SortableTable = (props) => {
  const key = useMemo(() => uuid(), [props.disabled]);
  return (
    <>
      <DataTable className="sortable-table" size="compact">
        <Thead>
          <Tr>
            {props.colHeaders &&
              props.colHeaders.map((colName, key) => (
                <Th key={key}>{colName.displayName}</Th>
              ))}
          </Tr>
        </Thead>
        {props.dataSource && props.dataSource.length > 0 && (
          <ReactSortable
            key={key}
            disabled={props.disabled}
            tag="tbody"
            className="vds-tbody"
            list={props.dataSource}
            setList={props.setDataSource}
            handle=".vss-handle"
            animation="150"
            easing="cubic-bezier(1, 0, 0, 1)"
          >
            {props.tableBody}
          </ReactSortable>
        )}
        {props.dataSource.length === 0 && (
          <Typography tag="h4" variant="subtitle">
            No records found
          </Typography>
        )}
      </DataTable>
    </>
  );
};

export default SortableTable;
